export const LOGIN = 'auth/LOGIN';
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
export const LOGIN_ERROR = 'auth/LOGIN_ERROR';

export const LOGOUT = 'auth/LOGOUT';
export const LOGOUT_SUCCESS = 'auth/LOGOUT_SUCCESS';
export const LOGOUT_ERROR = 'auth/LOGOUT_ERROR';

export const RECOVERY_PASSWORD = 'account/RECOVERY_PASSWORD';
export const RECOVERY_PASSWORD_SUCCESS = 'account/RECOVERY_PASSWORD_SUCCESS';
export const RECOVERY_PASSWORD_ERROR = 'account/RECOVERY_PASSWORD_ERROR';

export const CHANGE_PASSWORD = 'forgot-password/CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS =
  'forgot-password/CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_ERROR = 'forgot-password/CHANGE_PASSWORD_ERROR';

export const AUTH_ANONYMOUS = 'auth/AUTH_ANONYMOUS';
export const AUTH_ANONYMOUS_SUCCESS = 'auth/AUTH_ANONYMOUS_SUCCESS';
export const AUTH_ANONYMOUS_ERROR = 'auth/AUTH_ANONYMOUS_ERROR';

export const CHECK_LOCAL_AUTH = 'auth/CHECK_LOCAL_AUTH';
export const CHECK_LOCAL_AUTH_SUCCESS = 'auth/CHECK_LOCAL_AUTH_SUCCESS';
export const CHECK_LOCAL_AUTH_ERROR = 'auth/CHECK_LOCAL_AUTH_ERROR';

export const SET_VERIFY_ITEM_CHANGE_PASSWORD =
  'auth/SET_VERIFY_ITEM_CHANGE_PASSWORD';

export const CONFIRM_VERIFY_CODE_CHANGE_PASSWORD =
  'auth/CONFIRM_VERIFY_CODE_CHANGE_PASSWORD';
export const CONFIRM_VERIFY_CODE_CHANGE_PASSWORD_ERROR =
  'auth/CONFIRM_VERIFY_CODE_CHANGE_PASSWORD_ERROR';
export const CONFIRM_VERIFY_CODE_CHANGE_PASSWORD_SUCCESS =
  'auth/CONFIRM_VERIFY_CODE_CHANGE_PASSWORD_SUCCESS';

export const CHECK_LOCAL_AUTH_NOT_CLEAR_DATA_SUCCESS =
  'auth/CHECK_LOCAL_AUTH_NOT_CLEAR_DATA_SUCCESS';

export const LOG_OUT_NOT_CLEAR_DATA = 'auth/LOG_OUT_NOT_CLEAR_DATA';
